import { AddIcon, DownloadIcon } from "@/assets/icons";
import { uploadUserGroups } from "@/helpers/apis";
import { LoadingButton, Stack } from '@altimateai/lego'
import { ChangeEvent } from "react";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import UploadStatusModal from "./UploadStatusModal";
import { isOwner } from "@/services/auth";
import { Button, toast } from "@altimateai/lego";
import { UserGroupsCsvFileUrl } from "./assets";
import { Label } from "@/components/ui/label";

const UploadUserGroupsButton = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending: isLoading, data } = useMutation({
    mutationFn: uploadUserGroups,
    onSuccess: result => {
      if (!result) return;
      if (!result.failures.length) {
        toast({ description: "Teams uploaded successfully" });
        queryClient.invalidateQueries({ queryKey: ["UserGroups"] });
        queryClient.invalidateQueries({ queryKey: ["UserGroupDetails"] });
        return;
      }
    },
    onError: (error: Error) => {
      toast({ description: `Upload failed: ${error.message || error}`, variant: "destructive" });
    },
  });

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    mutate(formData);
  };

  if (!isOwner()) {
    return null;
  }

  return (
    <>
      <Stack>
        <Button
          title="Sample CSV files with required columns and possible values"
          variant="secondary"
          asChild
        >
          <a href={UserGroupsCsvFileUrl} download="user_groups_template.csv">
            <DownloadIcon />
            Download template
          </a>
        </Button>
        <LoadingButton
          className="btn-upload !al-p-0"
          loading={isLoading}
          title="Upload CSV file to create teams"
          aria-label="Upload CSV file to create teams"
        >
          <Label className={"al-flex al-gap-2 al-items-center al-cursor-pointer al-px-3 al-py-2"} htmlFor={"teams-file-upload"}>
            <AddIcon />
            Add teams
            <input
              id={"teams-file-upload"}
              type="file"
              className="al-hidden"
              onChange={handleFileUpload}
              accept={".csv"}
            />
          </Label>
        </LoadingButton>
      </Stack>
      <UploadStatusModal failures={data?.failures} success={data?.success} uploadType="userGroup" />
    </>
  );
};

export default UploadUserGroupsButton;
